import {
  COMPANY_DIR_ADD_TAGS_SUCCESS,
  COMPANY_DIR_ADD_VENDORS_SUCCESS,
  COMPANY_DIR_CLEAR_FILTER,
  COMPANY_DIR_EDIT_VENDORS_SUCCESS,
  COMPANY_DIR_FETCH_VENDORS,
  COMPANY_DIR_FILTER_VENDOR,
  COMPANY_DIR_FILTER_VENDOR_FAILURE,
  COMPANY_DIR_FILTER_VENDOR_SUCCESS,
  COMPANY_DIR_SEARCH_VENDORS,
  COMPANY_DIR_SEARCH_VENDORS_FAILURE,
  COMPANY_DIR_SEARCH_VENDORS_SUCCESS,
  COMPANY_DIR_DELETE_VENDORS_SUCCESS
} from "actions/companyDirectoryActions";
import produce from "immer";

const initialState = {
  error: false,
  message: "",
  searchKey: "",
  appliedFilters: {},
  vendors: [],
  totalCount: null,
  currentPage: null,
  totalPages: null,
  applyTagsCount: 0, //use this field for to update the tags so filter section trigger and they update the tags value
  loading: false,
  myVendorsCount: 0,
  myPendingCount: 0,
  myApprovedByMeCount: 0,
  myArchivedCount: 0,
  approvedCount: 0,
  pendingCount: 0,
  approvedByMeCount: 0,
  archivedCount: 0,
  vendorTypeCounts: {},
  disciplineCounts: {},
  categoryCounts: {},
  subCategoryCounts: {},
  makeCounts: {},
  makeCountsBySubCategory: {},
  vendorActivityCounts: {
    all: 0,
    withOrders: 0,
    withoutOrders: 0,
  },
  vendorInvitationCounts: {
    all: 0,
    invited: 0,
    nonInvited: 0,
  },
  locationFilterOptions: {
    cities: [],
    areas: [],
    cityAreas: [],
  },
  createdByFilterOptions: null,
};

const companyDirectory = (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_DIR_SEARCH_VENDORS:
    case COMPANY_DIR_FETCH_VENDORS:
    case COMPANY_DIR_FILTER_VENDOR: {
      const payload = action?.payload;
      return produce(state, (draft) => {
        draft.searchKey = payload?.searchKey || "";
        draft.appliedFilters = payload?.filterData || {};
        draft.loading = true;
      });
    }
    case COMPANY_DIR_SEARCH_VENDORS_SUCCESS:
    case COMPANY_DIR_FILTER_VENDOR_SUCCESS: {
      const vendor = action?.payload?.vendors;
      return produce(state, (draft) => {
        draft.vendors = vendor?.vendors;
        draft.totalCount = vendor?.totalCount;
        draft.currentPage = vendor?.currentPage;
        draft.totalPages = vendor?.totalPages;
        draft.myVendorsCount = vendor?.myVendorsCount ?? 0;
        draft.myPendingCount = vendor?.myPendingCount ?? 0;
        draft.myApprovedByMeCount = vendor?.myApprovedByMeCount ?? 0;
        draft.myArchivedCount = vendor?.myArchivedCount ?? 0;
        draft.approvedCount = vendor?.approvedCount ?? 0;
        draft.pendingCount = vendor?.pendingCount ?? 0;
        draft.approvedByMeCount = vendor?.approvedByMeCount ?? 0;
        draft.archivedCount = vendor?.archivedCount ?? 0;
        draft.vendorTypeCounts = vendor?.vendorTypeCounts ?? {};
        draft.disciplineCounts = vendor?.disciplineCounts ?? {};
        draft.categoryCounts = vendor?.categoryCounts ?? {};
        draft.subCategoryCounts = vendor?.subCategoryCounts ?? {};
        draft.makeCounts = vendor?.makeCounts ?? {};
        draft.makeCountsBySubCategory =
          vendor?.makeCountsBySubCategory ?? {};
        draft.vendorActivityCounts = vendor?.vendorActivityCounts ?? {
          all: 0,
          withOrders: 0,
          withoutOrders: 0,
        };
        draft.vendorInvitationCounts = vendor?.vendorInvitationCounts ?? {
          all: 0,
          invited: 0,
          nonInvited: 0,
        };
        draft.locationFilterOptions = vendor?.locationFilterOptions ?? {
          cities: [],
          areas: [],
          cityAreas: [],
        };
        draft.createdByFilterOptions = Array.isArray(
          vendor?.createdByFilterOptions,
        )
          ? vendor.createdByFilterOptions
          : null;
        draft.loading = false;
      });
    }
    case COMPANY_DIR_ADD_VENDORS_SUCCESS: {
      console.log("Adding vendor", action);
      return produce(state, (draft) => {
        draft.vendors = [action?.payload, ...state?.vendors];
      });
    }
    case COMPANY_DIR_EDIT_VENDORS_SUCCESS: {
      console.log("edit vendor", action);
      const newVendor = action.payload;
      const filteredVendors = state?.vendors?.map((vendor) => {
        if (vendor?.vendorId === newVendor.vendorId) return newVendor;
        return vendor;
      });
      return produce(state, (draft) => {
        draft.vendors = filteredVendors;
      });
    }

    case COMPANY_DIR_DELETE_VENDORS_SUCCESS: {
      const deletedVendorId = action.payload;
      const filteredVendors = state.vendors.filter(vendor => vendor.vendorId !== deletedVendorId);

      return produce(state, draft => {
        draft.vendors = filteredVendors;
      });
    }

    case COMPANY_DIR_SEARCH_VENDORS_FAILURE:
    case COMPANY_DIR_FILTER_VENDOR_FAILURE: {
      return produce(state, (draft) => {
        draft.vendors = [];
        draft.totalCount = null;
        draft.currentPage = null;
        draft.totalPages = null;
        draft.vendorTypeCounts = {};
        draft.disciplineCounts = {};
        draft.categoryCounts = {};
        draft.subCategoryCounts = {};
        draft.makeCounts = {};
        draft.makeCountsBySubCategory = {};
        draft.vendorActivityCounts = {
          all: 0,
          withOrders: 0,
          withoutOrders: 0,
        };
        draft.vendorInvitationCounts = {
          all: 0,
          invited: 0,
          nonInvited: 0,
        };
        draft.locationFilterOptions = {
          cities: [],
          areas: [],
          cityAreas: [],
        };
        draft.createdByFilterOptions = null;
        draft.loading = false;
      });
    }
    case COMPANY_DIR_CLEAR_FILTER: {
      return produce(state, (draft) => {
        draft.appliedFilters = {};
      });
    }
    case COMPANY_DIR_ADD_TAGS_SUCCESS: {
      return produce(state, (draft) => {
        draft.applyTagsCount = draft.applyTagsCount + 1;
        draft.vendors = state?.vendors?.map(
          (obj) =>
            action?.payload?.find(
              (replace) => replace?.vendorId === obj?.vendorId
            ) || obj
        );
      });
    }
    default: {
      return state;
    }
  }
};

export default companyDirectory;
